<template>
    <a-layout class="layout">
        <Header :menus="subMenus" @selectMenu="onOpenPageMenu" :selectMenuKey="selectSubMenuKey" />
        <a-layout class="ant-layout-has-sider">
            <Sider :collapsed="collapsed" @selectMenu="onSelectMenu" @selectBigScreenMenu="onSelectBigScreenMenu" :selectMenuKey="selectMenuKey" />
            <Content :menus="subMenus" @selectMenu="onOpenPageMenu" :selectMenuKey="selectSubMenuKey" />
        </a-layout>
    </a-layout>
</template>
<script>
import Header from "./header.vue";
import Sider from "./sider.vue";
import Content from "./content.vue";
export default {
    components: {
        Header,
        Sider,
        Content
    },
    name: 'Layout',
    data() {
        return {
            collapsed: false,
            subMenus: [],
            selectMenuKey: '',
            selectSubMenuKey: '',
        }
    },
    created() {},
    destroyed() {},
    mounted() {},
    methods: {
        onSelectMenu(menu) {
            let menus = menu.single ? [] : menu.children ? menu.children : []
            menu = menus.length ? menus[0] : menu
            this.onOpenPageMenu(menu)
        },
        onSelectBigScreenMenu(menu){
            window.open(menu.link, '_blank')
        },
        onOpenPageMenu(menu) {
            this.$router.push(menu.path)
        },
        findRoutesByPath(path) {
            let routes = this.$router.options.routes
            let obj = null
            routes.forEach((route) => {
                if (route.children && route.children.length) {
                    let subRoute = route.children.find((subRoute) => {
                        return subRoute.path == path
                    })
                    if (subRoute) {
                        obj = {
                            route: route,
                            subRoute: subRoute
                        }
                    }
                }
            })
            return obj
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                let curPath = to.path
                if (curPath == this.selectSubMenuKey) return
                let obj = this.findRoutesByPath(curPath)
                if (obj) {
                    let menu = obj.route
                    this.subMenus = menu.single ? [] : menu.children ? menu.children : []
                    this.selectMenuKey = obj.route.path
                    this.selectSubMenuKey = obj.subRoute.path
                }
            },
        },

    },
    props: {},
}
</script>
<style>
.layout {
    width: 100%;
    height: 100vh;
    overflow: hidden;
}
</style>